import React, { Fragment } from "react";
import { Card } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import GeneralSettingsForm from './GeneralSettingsForm';
import TransitionOnLoad from "Components/TransitionOnLoad";

const GeneralSettings = () => {

    return (
        <Fragment>
            <PageHeading />
           <TransitionOnLoad>
                    <GeneralSettingsForm />
                </TransitionOnLoad>
        </Fragment>
    )
}

export default GeneralSettings;
